export default "__VITE_ASSET__BEkwl4oc__"